export { default } from "./SuccessCard"